/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NivelHabilitacaoEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export const NivelHabilitacaoEnum = {

    NUMBER_1: 1 as NivelHabilitacaoEnum,

    NUMBER_2: 2 as NivelHabilitacaoEnum,

    NUMBER_3: 3 as NivelHabilitacaoEnum,

    NUMBER_4: 4 as NivelHabilitacaoEnum,

    NUMBER_5: 5 as NivelHabilitacaoEnum,

    NUMBER_6: 6 as NivelHabilitacaoEnum,

    NUMBER_7: 7 as NivelHabilitacaoEnum,

    NUMBER_8: 8 as NivelHabilitacaoEnum,

    NUMBER_9: 9 as NivelHabilitacaoEnum
};

